<template>
  <div class="welcome-container">
    <!-- Hero Banner -->
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-content container">
        <div class="hero-text-wrapper text-center">
          <h1 class="hero-title animate-fade-in">
            <span class="khmer-welcome font-moul">{{ $t("message.welcome") }}</span>
            <span class="english-welcome">Welcome</span>
          </h1>
          <h2 class="hero-subtitle-kh animate-slide-up">
            {{ $t("message.system_title") }}
          </h2>
          <p class="hero-subtitle-en animate-slide-up-delayed">
            ONLINE REGISTRATION AND PAYMENT FOR TRAINING, EXAMINATION AND CONTINUING PROFESSIONAL EDUCATION (CPE) IN SECURITIES SECTOR
          </p>
          <div class="hero-btn-container animate-fade-in-delayed">
            <button
              type="button"
              class="btn-premium-register animate-glow"
              @click="clickRegister"
            >
              <span>{{ $t("message.registration_training") }}</span>
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content Section -->
    <div class="main-sections">
      <!-- Section 1: How to use -->
      <section class="section-card-wrapper bg-dark-forest">
        <div class="container py-5">
          <div class="row align-items-center g-5">
            <div class="col-lg-6 col-md-12">
              <div class="video-container shadow-premium">
                <iframe
                  width="100%"
                  height="340"
                  src="https://www.youtube.com/embed/Adehq3jLwEE?si=udRPWAz6i2k7Vi1j"
                  title="ការចុះឈ្មោះ និងបង់ថ្លៃតាមអនឡាញ"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="info-content-card">
                <div class="card-icon-badge">
                  <i class="fas fa-play-circle"></i>
                </div>
                <h3 class="section-title">{{ $t("message.how_to_use") }}</h3>
                <p class="section-text" v-html="$t('message.how_to_use_desc')"></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Pathway Grid -->
      <section class="pathway-section py-5">
        <div class="container">
          <div class="row g-4">
            <!-- Training & Exam Card -->
            <div class="col-md-6 col-sm-12">
              <div class="pathway-card shadow-premium">
                <div class="pathway-icon">
                  <i class="fas fa-graduation-cap"></i>
                </div>
                <h3 class="pathway-title">{{ $t("message.training_exam_title") }}</h3>
                <p class="pathway-desc" v-html="$t('message.training_exam_desc')"></p>
              </div>
            </div>

            <!-- CPE Renewal Card -->
            <div class="col-md-6 col-sm-12">
              <div class="pathway-card shadow-premium highlight-gold">
                <div class="pathway-icon">
                  <i class="fas fa-sync-alt"></i>
                </div>
                <h3 class="pathway-title">{{ $t("message.cpe_title") }}</h3>
                <p class="pathway-desc" v-html="$t('message.cpe_desc')"></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickRegister() {
      if (typeof this.$store.getters.getAuth.access_token === "undefined") {
        this.$router.push({ name: "SingUp" });
      } else {
        this.$router.push({ name: "register" });
      }
    },
    handleScroll() {
      if (this.$route.name === 'Home') {
        if (window.scrollY >= 120) {
          if (!this.$store.getters.getTempalte.headerScroll) {
            this.$store.commit('changeTemplate', {
              headerScroll: 'navbar-transparent-scroll'
            });
          }
        } else {
          if (this.$store.getters.getTempalte.headerScroll) {
            this.$store.commit('changeTemplate', {
              headerScroll: ''
            });
          }
        }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.welcome-container {
  min-height: 100vh;
  background-color: #f4f5f7;
  color: #2c3e35;
  font-family: 'Battambang', 'Inter', sans-serif;
  overflow-x: hidden;
}

/* Hero Section */
.hero-section {
  position: relative;
  width: 100%;
  height: 95vh;
  background: url("~@/assets/images/bg.jpg") no-repeat center center fixed;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(8, 48, 24, 0.55) 0%,
    rgba(4, 24, 12, 0.7) 100%
  );
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 950px;
  padding: 24px;
}

.hero-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}

.khmer-welcome {
  font-family: 'Moul', 'Khmer Moul', cursive;
  font-size: 3rem;
  color: #ffc107;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8), 0 4px 15px rgba(255, 193, 7, 0.4);
}

.english-welcome {
  font-family: 'Outfit', 'Inter', sans-serif;
  font-size: 1.6rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 4px;
  text-transform: uppercase;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
}

.hero-subtitle-kh {
  font-size: 1.5rem;
  line-height: 1.8;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 16px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9);
}

.hero-subtitle-en {
  font-family: 'Outfit', 'Inter', sans-serif;
  font-size: 0.95rem;
  line-height: 1.6;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.5px;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9);
}

/* Premium Button */
.btn-premium-register {
  position: relative;
  background: linear-gradient(135deg, #0e8937 0%, #0a5c2c 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  padding: 16px 40px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(14, 137, 55, 0.3);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 1;
}

.btn-premium-register::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  z-index: -1;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.btn-premium-register:hover {
  color: #050b07;
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 12px 30px rgba(255, 193, 7, 0.4);
  border-color: transparent;
}

.btn-premium-register:hover::before {
  opacity: 1;
}

.btn-premium-register i {
  transition: transform 0.3s ease;
}

.btn-premium-register:hover i {
  transform: translateX(4px);
}

/* Animations */
.animate-fade-in {
  animation: fadeIn 1s ease-out forwards;
}

.animate-slide-up {
  animation: slideUp 1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.animate-slide-up-delayed {
  opacity: 0;
  animation: slideUp 1s cubic-bezier(0.4, 0, 0.2, 1) 0.3s forwards;
}

.animate-fade-in-delayed {
  opacity: 0;
  animation: fadeIn 1s ease-out 0.6s forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Main Sections Content */
.main-sections {
  background-color: #f4f5f7;
}

.bg-dark-forest {
  background: linear-gradient(180deg, #ffffff 0%, #f1f3f5 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.video-container {
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.video-container:hover {
  transform: translateY(-5px);
}

.video-container iframe {
  display: block;
}

.info-content-card {
  padding: 35px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

.card-icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: rgba(14, 137, 55, 0.1);
  border: 1.5px solid #0e8937;
  border-radius: 12px;
  color: #0e8937;
  font-size: 24px;
  margin-bottom: 20px;
  margin-right: 20px;
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0a5c2c;
  margin-bottom: 16px;
  position: relative;
  display: inline-block;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 40px;
  height: 3px;
  background: #ffc107;
  border-radius: 2px;
}

.section-text {
  font-size: 1.05rem;
  line-height: 1.8;
  color: #3e4e44;
  text-align: justify;
}

/* Pathway section */
.pathway-section {
  background: #f4f5f7;
}

.pathway-card {
  height: 100%;
  padding: 40px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.pathway-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #0e8937;
  opacity: 0.8;
}

.pathway-card.highlight-gold::before {
  background: #ffc107;
}

.pathway-card:hover {
  transform: translateY(-8px);
  border-color: rgba(14, 137, 55, 0.2);
  box-shadow: 0 20px 40px rgba(14, 137, 55, 0.12);
}

.pathway-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: rgba(14, 137, 55, 0.1);
  border-radius: 16px;
  color: #0e8937;
  font-size: 28px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.pathway-card.highlight-gold .pathway-icon {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.pathway-card:hover .pathway-icon {
  transform: scale(1.1) rotate(5deg);
}

.pathway-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #0a5c2c;
  margin-bottom: 16px;
}

.pathway-desc {
  font-size: 0.98rem;
  line-height: 1.8;
  color: #4a5c50;
  text-align: justify;
}

/* Responsive Styles */
@media (max-width: 991px) {
  .khmer-welcome {
    font-size: 2.2rem;
  }
  .hero-subtitle-kh {
    font-size: 1.25rem;
  }
  .pathway-card {
    padding: 30px;
  }
}

@media (max-width: 576px) {
  .khmer-welcome {
    font-size: 1.8rem;
  }
  .english-welcome {
    font-size: 1.2rem;
    letter-spacing: 2px;
  }
  .hero-subtitle-kh {
    font-size: 1.1rem;
    line-height: 1.6;
  }
  .hero-subtitle-en {
    font-size: 0.85rem;
  }
  .btn-premium-register {
    padding: 12px 28px;
    font-size: 0.95rem;
  }
  .info-content-card {
    padding: 20px;
  }
  .section-title {
    font-size: 1.4rem;
  }
  .pathway-card {
    padding: 24px;
  }
}
</style>
